import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';

import { Link } from "react-router-dom";


export default function SliderHomeOurBlog() {
    return (
        <>
            <Swiper
                slidesPerView={1}
                spaceBetween={10}

                autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                }}
                breakpoints={{
                    '@0.00': {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },
                    '@0.75': {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },
                    '@1.00': {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },
                    '@1.50': {
                        slidesPerView: 3,
                        spaceBetween: 10,
                    },
                }}
                modules={[Autoplay]}
                className="mySwiper mb-lg-4"
            >
                <SwiperSlide>
                    <div className="swiper-slide swiper-slide-active" role="group" aria-label="1 / 4" style={{ width: 356, marginRight: 24 }} data-swiper-slide-index={0}>
                        <div className="blog-single-item-1">
                            <div className="img-block">
                                <img src="assets/img/Blog_1.png" alt="blog-img-1" width={374} height={292} className="img-fluid w-100" />
                            </div>
                            <div className="post-meta-data">
                                <span>12 Dec, 2024</span>
                            </div>
                            <Link to="/truck-express" className="d-5 blog-title-link"> Truck Express Services for Quick Delivery</Link>
                            <Link to="/truck-express" className="btn-details">
                                Read More
                                <div className="btn-icon">
                                    <span>
                                        <i className="fa-regular fa-arrow-right-long" />
                                    </span>
                                    <span>
                                        <i className="fa-regular fa-arrow-right-long" />
                                    </span>
                                </div>
                            </Link>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide swiper-slide-next" role="group" aria-label="2 / 4" data-swiper-slide-index={1} style={{ width: 356, marginRight: 24 }}>
                        <div className="blog-single-item-1">
                            <div className="img-block">
                                <img src="assets/img/Blog_2.png" alt="blog-img-2" width={374} height={292} className="img-fluid w-100" />
                            </div>
                            <div className="post-meta-data">
                                <span>12 May, 2025</span>
                            </div>
                            <Link to="/best-logistics" className="d-5 blog-title-link">Best logistics company in India</Link>
                            <Link to="/best-logistics" className="btn-details">
                                Read More
                                <div className="btn-icon">
                                    <span>
                                        <i className="fa-regular fa-arrow-right-long" />
                                    </span>
                                    <span>
                                        <i className="fa-regular fa-arrow-right-long" />
                                    </span>
                                </div>
                            </Link>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide" role="group" aria-label="3 / 4" data-swiper-slide-index={2} style={{ width: 356, marginRight: 24 }}>
                        <div className="blog-single-item-1">
                            <div className="img-block">
                                <img src="assets/img/Blog_3.png" alt="blog-img-3" width={374} height={292} className="img-fluid w-100" />
                            </div>
                            <div className="post-meta-data">
                                <span>12 July, 2025</span>
                            </div>
                            <Link to="/book-air" className="d-5 blog-title-link">Book Air Cargo Services for Domestic Routes</Link>

                            <Link to="/book-air" className="btn-details">
                                Read More
                                <div className="btn-icon">
                                    <span>
                                        <i className="fa-regular fa-arrow-right-long" />
                                    </span>
                                    <span>
                                        <i className="fa-regular fa-arrow-right-long" />
                                    </span>
                                </div>
                            </Link>
                        </div>
                    </div>
                </SwiperSlide>



            </Swiper>
        </>
    );
}
